import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { faArrowsAltV } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch } from 'react-redux'
import { reorderOptions } from 'store/Quiz/actions'

const portal = document.createElement('div')
document.body.appendChild(portal)

function PortalAwareItem({ provided, snapshot, value, key }) {
	const usePortal = snapshot.isDragging

	const child = (
		<div
			className={`col-12 mb-2 p-2 border rounded draggable-item  draggable-bg   ${
				snapshot.isDragging ? 'active' : ''
			}`}
			{...provided.draggableProps}
			{...provided.dragHandleProps}
			ref={provided.innerRef}
			key={key}
		>
			<FontAwesomeIcon icon={faArrowsAltV} />
			<span className='quiz-option-label'>{value}</span>
		</div>
	)

	if (!usePortal) {
		return child
	}

	return ReactDOM.createPortal(child, portal)
}
export const SortableList = ({ options }) => (
	<Droppable droppableId='droppable' direction='vertical'>
		{(provided) => (
			<div
				className='sortable-items-wrapper'
				ref={provided.innerRef}
				{...provided.droppableProps}
			>
				{options.map((value, index) => {
					return (
						<Draggable
							key={value.id}
							draggableId={value.id.toString()}
							index={index}
						>
							{(draggableProvided, draggableSnapshot) => (
								<PortalAwareItem
									provided={draggableProvided}
									snapshot={draggableSnapshot}
									key={`item-${index}`}
									value={value.name}
								/>
							)}
						</Draggable>
					)
				})}
				{provided.placeholder}
			</div>
		)}
	</Droppable>
)

const SortableComponent = ({ options, onReorder }) => {
	const [sortableOptions, setSortableOptions] = useState(options)
	const dispatch = useDispatch()
	const onDragEnd = (result) => {
		if (!result.destination) {
			return
		}

		const updatedOptions = [...sortableOptions]
		const [removed] = updatedOptions.splice(result.source.index, 1)
		updatedOptions.splice(result.destination.index, 0, removed)

		setSortableOptions(updatedOptions)
		dispatch(reorderOptions(updatedOptions))
	}

	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<SortableList options={sortableOptions} />
		</DragDropContext>
	)
}

export default SortableComponent
